import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { Link } from "react-router-dom";

const KycDialogBox = ({ open, onCancel, onOK }) => {
    return (
        <DiaglogBox width={400} open={open} onCancel={onCancel}>
            <div className="pb-5">
                <h4
                    className="pt-8 pb-9 w-full text-black text-[1.5625rem] font-bold text-center"
                    style={{
                        background: "url('/images/purple_wave_bg.svg')",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    Notification
                </h4>
                <p className="text-center font-bold text-[17px] px-11">
                    To buy Carbon credit you have to complete KYC first!
                </p>
                <div className="px-10 flex justify-between mt-4">
                    <Link to={"/kyc"}>
                        <Button
                            color={"blue"}
                            className={
                                "w-[150px] h-[40px] text-white text-sm font-bold"
                            }
                            varient={"primary"}
                        >
                            Ok
                        </Button>
                    </Link>

                    <Button
                        borderColor={"blue"}
                        onClick={onCancel}
                        className={
                            "w-[150px] h-[40px] text-blue-800 text-sm font-bold"
                        }
                        varient={"primary"}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </DiaglogBox>
    );
};

export default KycDialogBox;
